import React from 'react';
import {
    Card,
    StyledAction
  } from "baseui/card";
import { Button, SIZE } from "baseui/button";
import PropTypes from 'prop-types';
import emailIcon from '../../../../../../assets/img/email-icon.svg';
import mailSentIcon from '../../../../../../assets/img/mail-sent-check.svg';
import { useSelector } from 'react-redux';
import { Spinner, SIZE as SpinnerSize } from 'baseui/spinner';
import './MainBody.scss';
import { getName } from '../../../../../util/getUserFullName';
import useEmailSentSuccess from '../hooks/useEmailSentSuccess';

const MainBody = ({ mail_sent=false, sending_error=false, sendDesktopLoginMail, loading }) => {
    let name = getName();
    if (!name) {
        const state = useSelector((state) => ({ basic_info_page: state.basic_info_page }))
        const basic_info_page = state.basic_info_page;
        name = basic_info_page.firstName
    }

    useEmailSentSuccess(mail_sent, sending_error)

    return (
        <div className='turing-mobile-home-body'>
            <Card overrides={{
                Root: {
                    style: {
                        border: '1px solid #EDEDED'
                    }
                },
                Body: {
                    style: {
                        gap: '16px'
                    }
                }
            }}>
                <h4 className='turing-mobile-home-body__heading'>Welcome{name ? `, ${name}!` : ''}</h4>
                <div className='turing-mobile-home-body__info'>
                    <div>
                        <p>
                            Thanks for joining Turing! Your next step is to complete the assessment process to become eligible for top remote tech jobs.
                            Please note that this step is currently only available on desktop.
                        </p>
                        <p>
                            Would you like us to send a login link to your email? This way, you can easily pick up where you left off on your desktop or laptop.
                        </p>
                    </div>
                    <div>
                        <StyledAction>
                            <Button
                                disabled={mail_sent}
                                onClick={sendDesktopLoginMail}
                                size={SIZE.compact}
                                colors={{ backgroundColor: '#2F6AE3', color: '#fff' }}
                                overrides={{
                                BaseButton: {
                                    style: {
                                        width: "100%",
                                        gap: "8px"
                                    }
                                }
                                }}
                            >
                                {loading && <Spinner $color='#fff' $size={SpinnerSize.small} />}
                                <img src={mail_sent ? mailSentIcon : emailIcon} alt="E" /> {mail_sent ? 'Login link sent to your email' : 'Send login link for desktop'} 
                            </Button>
                        </StyledAction>
                    </div>
                </div>
            </Card>
        </div>
    )
}

MainBody.propTypes = {
    mail_sent: PropTypes.bool,
    sending_error: PropTypes.bool,
    sendDesktopLoginMail: PropTypes.func,
    loading: PropTypes.bool
}

export default MainBody